import { render } from "./OutputInfo.vue?vue&type=template&id=bc0f5ae6&scoped=true"
import script from "./OutputInfo.vue?vue&type=script&lang=js"
export * from "./OutputInfo.vue?vue&type=script&lang=js"

import "./OutputInfo.vue?vue&type=style&index=0&id=bc0f5ae6&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0f5ae6"]])

export default __exports__